export default "__VITE_ASSET__Dm4PbGO9__"